// WHO BEARS THIS COST — where it finally lands, and nothing else.
//
// The mirror of PayerCell, and deliberately a separate column from it: that one answers
// "whose money went out", this one answers "where does the cost finally land". They are
// independent — a cost can be paid and absorbed, or unpaid and charged on — and folding
// them into one cell would invent a relationship the data does not have.
//
// THREE BEARER STATES, NOT TWO. A row recorded before the question existed (migration
// 054) is shown as "לא צוין" rather than as absorbed. It is the whole reason the column is
// not a boolean: reading "never asked" as "we absorb this" is what would make the
// per-client cost view quietly overstate what a client costs us.
//
//   blue · על הלקוח                    the client bears it
//   blue · על הלקוח + החיוב בוטל       its charge was cancelled, so nothing is asked
//   gray · עלינו                       we absorb it
//
// NO COLLECTION STATE, AND ONE COLOUR PER BEARER. An expense table is about paying
// suppliers. Whether the client has paid the charge — late, collected — is the money
// screen's question and the job page's collection strip; shown here it followed the
// charge's due date and read as something wrong with the expense. What was asked is its
// own column (AskedCell); "החיוב בוטל" stays because it is why that column is a dash.
import he from '../i18n/he';
import { isChargedOn, isAbsorbed, isCharged } from '../utils/expenses';

export default function BearerCell({ expense }) {
  if (isChargedOn(expense)) {
    const collection = expense.charge_collection;
    const cancelled = isCharged(expense) && !!collection && !!collection.cancelled;
    return (
      <>
        <span className="badge blue">{he.expenses.borneClient}</span>
        {cancelled && (
          <span className="muted small-note" style={{ marginInlineStart: 6 }}>
            {he.expenses.chargeCancelled}
          </span>
        )}
      </>
    );
  }
  if (isAbsorbed(expense)) return <span className="badge gray">{he.expenses.borneUs}</span>;
  return <span className="muted">{he.expenses.borneUnstated}</span>;
}
